import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  onClick?: () => void
}

/**
 * Cards are `panel` on `ground` with a hairline and a 16px radius
 * (UI_SDD §R.1, DEC-127.5).
 *
 * Depth is the ground → panel surface step plus the hairline, not a shadow: the
 * design system's shadow ramp tops out at rgba(17,17,17,.10) and is invisible
 * on the ground (DEC-127.6). An interactive card therefore lifts by brightening
 * its hairline rather than by deepening a shadow nobody can see.
 *
 * Padding is the caller's, so a dense in-app card is not forced to the design
 * system's 32px marketing padding.
 */
export function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div
      className={`bg-panel border border-hairline rounded-lg shadow-card ${onClick ? 'cursor-pointer hover:border-hairline-strong transition-colors' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
